import React from 'react'
import Enrollment from './Enrollment';
import AddEnrollment from './AddEnrollment';
import ViewEnrollment from './ViewEnrollment';
import EditEnrollment from './EditEnrollment';
import { Routes, Route } from "react-router-dom";

const MainEnrollment = () => {
  return (
    <div className='bg-gray-100 text-gray-900 px-4 dark:bg-gray-900 dark:text-white'>
      <Routes>
          <Route path='/' element={<Enrollment/>}></Route>
          <Route path='/add-enrollment' element={<AddEnrollment/>}></Route>
          <Route path='/view-enrollment' element={<ViewEnrollment/>}></Route>
          <Route path='/edit-enrollment' element={<EditEnrollment/>}></Route>
      </Routes>
    </div>
  )
}

export default MainEnrollment
